import ListView from '@ingka/list-view';
import type { AssetMessage } from '@repo/types/messages';
import { type MessageTab, MessageTabs } from '@repo/types/messages-tabs';
import { NoBodyMessage } from '@repo/ui';

import { MessageItem } from './message-item.component';

type TranslateFunction = (key: string, params?: Record<string, string>) => string;

const tabConfigurations: Record<MessageTab, { noMessagesBodyKey: string }> = {
    [MessageTabs.TSP_CUST]: {
        noMessagesBodyKey: 'messages_modal_no_customer_body',
    },
    [MessageTabs.INTERNAL]: {
        noMessagesBodyKey: 'messages_modal_no_internal_body',
    },
    [MessageTabs.EXTERNAL]: {
        noMessagesBodyKey: 'messages_modal_no_transport_body',
    },
};

interface Props {
    messages: AssetMessage[];
    messageType: AssetMessage['messageType'];
    translate: TranslateFunction;
    dateTimeFormat: string;
    onMessageClick: (message: AssetMessage) => void;
    enableEdit: boolean;
}

export const MessageList = ({
    messages,
    messageType,
    translate,
    dateTimeFormat,
    onMessageClick,
    enableEdit,
}: Props) => {
    if (messages.length === 0) {
        return (
            <NoBodyMessage
                title={translate('messages_modal_no_title')}
                body={translate(tabConfigurations[messageType].noMessagesBodyKey)}
            />
        );
    }

    return (
        <ListView id="message-list" aria-label="message-list">
            {messages.map((message) => (
                <MessageItem
                    key={message.orderMessageId}
                    message={message}
                    translate={translate}
                    dateTimeFormat={dateTimeFormat}
                    enableEdit={enableEdit}
                    onMessageClick={onMessageClick}
                />
            ))}
        </ListView>
    );
};
